<template>
    <div>
        <NevsSimpleGrid :fields="fields" :records="records" :empty-text="$LANG.Get('labels.noInvoices')"
                        @row-click="(record) => openInvoice(record.id)">
            <template #cell-status="{ record }">
                <span :class="'status-pill-' + record.invoice_status_id">{{ record.status_display }}</span>
            </template>
            <template #actions="{ record }">
                <span v-if="!record.imported" :title="$LANG.Get('tooltips.pdf')" class="invoices-grid-button"
                      @click="downloadPdf(record.pdf_link)"><i class="fa-solid fa-file-pdf"></i></span>
                <span :title="$LANG.Get('tooltips.openInNewWindow')" class="invoices-grid-button"
                      @click="openInvoice(record.id, true)"><i class="fa-solid fa-up-right-from-square"></i></span>
            </template>
        </NevsSimpleGrid>
        <div v-if="records.length < totalRecords" class="invoices-grid-load-more">
            <NevsButton @click="loadMore"><i class="fa-solid fa-chevron-down"></i> {{ $LANG.Get('buttons.loadMore') }}</NevsButton>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSimpleGrid from "@/components/nevs/NevsSimpleGrid.vue";

export default {
    name: "InvoicesGrid",
    components: {NevsSimpleGrid, NevsButton},
    props: {
        endpoint: String
    },
    data() {
        return {
            records: [],
            totalRecords: 0,
            page: 1,
            crossTabHandle: null,
            fields: [
                {name: 'number', label: this.$LANG.Get('fields.number')},
                {name: 'date_of_issue_display', label: this.$LANG.Get('fields.dateOfIssue')},
                {name: 'customer_display', label: this.$LANG.Get('fields.customer')},
                {name: 'status', label: this.$LANG.Get('fields.status')},
                {name: 'amount_display', label: this.$LANG.Get('labels.amount')},
                {name: 'financial_status_display', label: this.$LANG.Get('labels.open')},
                {name: 'payment_method_display', label: this.$LANG.Get('fields.paymentMethod')}
            ]
        }
    },
    methods: {
        load() {
            let vm = this;
            this.$API.APICall('get', this.endpoint, {page: this.page}, (data, success) => {
                if (success) {
                    vm.records = vm.records.concat(data.records);
                    vm.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        loadMore() {
            this.page++;
            this.load();
        },
        // Re-reads the list from the first page. `load()` appends, so the pages loaded so far are dropped
        // rather than duplicated - the newest invoice is on the first page anyway.
        reload() {
            this.page = 1;
            this.records = [];
            this.load();
        },
        openInvoice(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/invoices/' + id + '/edit');
                window.open(routeData.href);
            } else {
                this.$router.push('/invoices/' + id + '/edit');
            }
        },
        downloadPdf(link) {
            window.open(link);
        }
    },
    mounted() {
        this.load();
        // Every invoice saved through EntityInvoice (or the quick-invoice modal) fires this, in this tab and
        // in every other one - see Helpers.SubmitInvoice. It is how the grid picks up an invoice created on
        // the screen the "Novi račun" button opened in a new tab.
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-invoices', () => {
            vm.reload();
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.invoices-grid-button {
    cursor: pointer;
}

.invoices-grid-load-more {
    margin-top: 10px;
}

.status-pill-1, .status-pill-2, .status-pill-3, .status-pill-4, .status-pill-5 {
    display: inline-block;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-1 {
    background: $info;
}

.status-pill-2 {
    background: $amber;
}

.status-pill-3 {
    background: $success-badge;
}

.status-pill-4 {
    background: $danger-bright;
}

.status-pill-5 {
    background: $success-badge;
}
</style>
